import apiClient from './meta-client';

/**
 * Categoria/pasta de utility template — nomeação livre pelo usuário, sem
 * hierarquia e sem vínculo a país. Não confundir com `category_ids` de
 * `UtilityTemplateGroup` (categoria de PÁGINA, derivada de `internal_category_id`).
 */
export interface UtilityTemplateCategory {
    id: number;
    name: string;
    created_at?: string;
    updated_at?: string;
}

export const getUtilityTemplateCategories = async (): Promise<UtilityTemplateCategory[]> => {
    const response = await apiClient.get<UtilityTemplateCategory[]>('/meta/utility-template-categories');
    return response.data;
};

export const createUtilityTemplateCategory = async (name: string): Promise<UtilityTemplateCategory> => {
    const response = await apiClient.post<UtilityTemplateCategory>('/meta/utility-template-categories', { name });
    return response.data;
};

export const renameUtilityTemplateCategory = async (
    categoryId: number,
    name: string
): Promise<UtilityTemplateCategory> => {
    const response = await apiClient.patch<UtilityTemplateCategory>(
        `/meta/utility-template-categories/${categoryId}`,
        { name }
    );
    return response.data;
};

export const deleteUtilityTemplateCategory = async (categoryId: number): Promise<{ success: boolean }> => {
    const response = await apiClient.delete<{ success: boolean }>(
        `/meta/utility-template-categories/${categoryId}`
    );
    return response.data;
};

/** Substitui totalmente o conjunto de categorias associadas ao grupo. */
export const setGroupUtilityCategories = async (
    groupId: number,
    utilityCategoryIds: number[]
): Promise<{ success: boolean } | void> => {
    const response = await apiClient.put(`/meta/utility-templates/groups/${groupId}/categories`, {
        utility_category_ids: utilityCategoryIds,
    });
    return response.data;
};
